<script lang="ts">
	import { Icon } from '@Shelly/shelly-design-system';

	/** Banner image URL */
	export let image: string;
	/** Image alt text */
	export let alt: string = '';
	/** Show "Active" badge */
	export let showActiveBadge: boolean = true;
	/** Active badge label text */
	export let activeBadgeLabel: string = 'Active';
	/** Expiry text (e.g., "Expires in 8 days"). Hidden when empty. */
	export let expiryText: string = '';
	/** Position of the overlay */
	export let overlayPosition: 'top' | 'bottom' = 'bottom';
	/** CSS aspect-ratio for the banner container (e.g. "600 / 400"). */
	export let aspectRatio: string = '600 / 400';
</script>

<div class="promo-modal-banner" style="aspect-ratio: {aspectRatio};">
	<img class="promo-modal-banner__image" src={image} {alt} />
	<div class={`promo-modal-banner__overlay ${overlayPosition}`}>
		{#if showActiveBadge}
			<div class="active-badge">
				<Icon icon="fas fa-bolt" size="xs" class="active-badge__icon" />
				<span class="active-badge__text">{activeBadgeLabel}</span>
			</div>
		{/if}
		{#if expiryText}
			<div class="expiry-badge">
				<span class="expiry-badge__text">{expiryText}</span>
			</div>
		{/if}
	</div>
</div>

<style>
	.promo-modal-banner {
		position: relative;
		width: 100%;
		flex-shrink: 0;
	}

	.promo-modal-banner__image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	.promo-modal-banner__overlay {
		position: absolute;
		left: 12px;
		right: 12px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.promo-modal-banner__overlay.top {
		top: 8px;
		bottom: auto;
	}

	.promo-modal-banner__overlay.bottom {
		top: auto;
		bottom: 8px;
	}

	.active-badge {
		display: flex;
		align-items: center;
		gap: 4px;
		height: 32px;
		padding: 6px 12px 6px 10px;
		background: var(--color-base, #151617);
		border-radius: 16px;
		box-sizing: border-box;
	}

	:global(.active-badge__icon) {
		color: var(--color-success, #66d092) !important;
		text-shadow: 0 0 14px var(--color-success, #66d092);
	}

	.active-badge__text {
		font-family: 'Inter', sans-serif;
		font-size: 12px;
		font-weight: 500;
		line-height: normal;
		color: var(--color-white, #ffffff);
	}

	.expiry-badge {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 4px 8px;
		background: rgba(36, 37, 39, 0.7);
		border-radius: 40px;
	}

	.expiry-badge__text {
		font-family: 'Inter', sans-serif;
		font-size: 13px;
		font-weight: 400;
		line-height: 16px;
		color: var(--color-white, #ffffff);
		white-space: nowrap;
	}
</style>
